/**
 * Library — Constants
 */

export const LS_KEY_DOCUMENTS = "mcm_library_documents";

export const DOCUMENT_CATEGORIES = [
  "Certification",
  "Contract",
  "Evaluation",
  "Training",
  "License",
  "Other",
];
